import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Layout from "./Layout";

export default function ProtectedRoute({ children }: { children: ReactNode }) {
  const { username, loading } = useAuth();

  if (loading) return <div className="empty-state">Loading…</div>;
  if (!username) return <Navigate to="/login" replace />;

  return <Layout>{children}</Layout>;
}
